export function formatINR(amount) {
  if (amount == null || isNaN(amount)) return '₹0';
  const num = Number(amount);
  if (num >= 10000000) return `₹${(num / 10000000).toFixed(2)} Cr`;
  if (num >= 100000) return `₹${(num / 100000).toFixed(2)} L`;
  return '₹' + num.toLocaleString('en-IN');
}

export function formatINRFull(amount) {
  if (amount == null || isNaN(amount)) return '₹0';
  return '₹' + Number(amount).toLocaleString('en-IN');
}

export function formatDate(dateStr) {
  if (!dateStr) return '-';
  try {
    const d = new Date(dateStr);
    return d.toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric', timeZone: 'Asia/Kolkata' });
  } catch { return dateStr; }
}

export function formatDateTime(dateStr) {
  if (!dateStr) return '-';
  try {
    const d = new Date(dateStr);
    return d.toLocaleString('en-IN', { day: '2-digit', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit', timeZone: 'Asia/Kolkata' });
  } catch { return dateStr; }
}

export function formatPhone(phone) {
  if (!phone) return '-';
  return phone;
}

export const STATUS_COLORS = {
  new: 'bg-blue-100 text-blue-800',
  assigned: 'bg-indigo-100 text-indigo-800',
  first_call_pending: 'bg-purple-100 text-purple-800',
  contacted: 'bg-violet-100 text-violet-800',
  qualified: 'bg-sky-100 text-sky-800',
  visit_scheduled: 'bg-amber-100 text-amber-800',
  visit_completed: 'bg-orange-100 text-orange-800',
  revisit: 'bg-yellow-100 text-yellow-800',
  negotiation: 'bg-pink-100 text-pink-800',
  token_received: 'bg-teal-100 text-teal-800',
  booked: 'bg-emerald-100 text-emerald-800',
  lost: 'bg-red-100 text-red-800',
  nurturing: 'bg-slate-100 text-slate-700',
};

export const STATUS_LABELS = {
  new: 'New Lead', assigned: 'Assigned', first_call_pending: 'First Call Pending',
  contacted: 'Contacted', qualified: 'Qualified', visit_scheduled: 'Visit Scheduled',
  visit_completed: 'Visit Done', revisit: 'Revisit', negotiation: 'Negotiation',
  token_received: 'Token Received', booked: 'Booked', lost: 'Lost', nurturing: 'Nurturing',
};

export const TEMP_COLORS = {
  hot: 'bg-red-500 text-white',
  warm: 'bg-amber-500 text-white',
  cold: 'bg-blue-500 text-white',
};

export const SOURCE_LABELS = {
  facebook: 'Facebook', instagram: 'Instagram', google_ads: 'Google Ads',
  property_portals: 'Property Portals', website: 'Website', walk_in: 'Walk-in',
  referral: 'Referral', channel_partner: 'Channel Partner', outbound_calling: 'Outbound Calling',
  '99acres': '99acres', 'housing_com': 'Housing.com', 'magicbricks': 'MagicBricks',
  other: 'Other',
};

export function apiErrorMsg(err) {
  const detail = err?.response?.data?.detail;
  if (!detail) return err?.message || 'Something went wrong';
  if (typeof detail === 'string') return detail;
  if (Array.isArray(detail)) return detail.map(e => e?.msg || JSON.stringify(e)).join(' ');
  if (detail?.msg) return detail.msg;
  return String(detail);
}
